import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    flexDirection: 'column',
    padding: '0px 15px',
    width: '100%'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 0',
    alignItems: 'center'
  },
  herderTitle: { display: 'flex', flexDirection: 'column', gap: 6 },
  greyText: { fontWeight: 500, color: theme.palette.grey[600] },
  whiteText: {
    color: theme.palette.primary.contrastText,
    fontWeight: 500,
    justifyContent: 'center',
    minWidth: 50
  },
  pmsEvent: { display: 'flex' },
  icon: { fontSize: 30 },
  startIcon: { fontsize: 18, color: theme.palette.grey[600] },
  basicDetails: {
    display: 'grid',
    gridTemplateColumns: '4fr 1.15fr',
    gap: theme.spacing(2),
    margin: '16px 0 8px 0'
  },
  btn: { background: theme.palette.grey[200], boxShadow: 'none' },
  btn2: {
    background: theme.palette.secondary.main,
    boxShadow: 'none',
    marginLeft: 16
  },
  moreIcon: { fontSize: 20, background: theme.palette.grey[200] },
  divider: { margin: '16px 0' },
  btnsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: theme.spacing(2)
  },
  button: {
    marginLeft: '32px',
    height: '32px',
    [theme.breakpoints.down('sm')]: {
      marginTop: 4,
      marginLeft: 0
    }
  },
  btnText: {
    color: theme.palette.primary.contrastText,
    fontWeight: 500
  },
  confirmBtn: { marginRight: 16, boxShadow: 'none' },
  redText: { color: theme.palette.primary.main, fontWeight: 500 },

  detailsContainer: { margin: '16px 0' },
  savebtn: { fontWeight: 600 },
  headerTitle: { color: theme.palette.text.primary },
  useBookerInfo: {
    display: 'flex',
    background: theme.palette.grey[200],
    alignItems: 'center',
    padding: 16,
    justifyContent: 'space-between',
    margin: '8px 0',
    borderRadius: 8,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  text: { fontWeight: 500, color: theme.palette.text.primary },
  left: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center'
    }
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))
export default useStyles
